export const columnIndicatorColors: Record<string, string> = {
	backlog: "var(--color-text-primary)",
	in_progress: "var(--color-accent)",
	review: "var(--color-accent-2)",
	trash: "var(--color-status-red)",
};

export const columnBackgroundColors: Record<string, string> = {
	backlog: "var(--color-surface-0)",
	in_progress: "var(--color-surface-0)",
	review: "var(--color-surface-0)",
	trash: "var(--color-surface-0)",
};
